import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutLoadBoardsTable extends Layout {
    sourceLoadboards: DataSource;
    sourceMovement: DataSource;
    tableLoadboards: Table;
}
